import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BeerHiveButtonProvider } from '../beer-hive-button/beer-hive-button';

/*
  Generated class for the BeerHiveSearchProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class BeerHiveSearchProvider {

  private buttons: Array<any>;

  constructor(public http: HttpClient, private beerHiveButtonProvider: BeerHiveButtonProvider) {
    console.log('Hello BeerHiveSearchProvider Provider');
    this.buttons = beerHiveButtonProvider.getButtons();
  }
  public getButtons(): Array<any> {
    return this.buttons;
  }

}
